import {
  HIRING_FOR_DEFAULT,
  JOB_INDUSTRY_DEFAULT,
  JOB_CATEGORY_DEFAULT,
  WORKPLACE_PREFERENCES,
} from '../../templateSettings/helper/constants';

export const getDefaultJobFieldSettings = () => {
  return {
    salaryTimeSpan: {
      disabled: false,
      label: 'Time Span',
      availableFields: [''],
      selectedField: '',
      mandatory: false,
      hide: false,
      selectedFields: [],
    },
    title: {
      mandatory: true,
      hide: false,
      disabled: true,
      label: 'Job Title',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    jobCode: {
      mandatory: true,
      hide: false,
      disabled: true,
      label: 'Job Code',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    locations: {
      mandatory: true,
      hide: false,
      disabled: true,
      label: 'Locations',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    description: {
      mandatory: true,
      hide: false,
      disabled: true,
      label: 'Job Description',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    compensation: {
      mandatory: false,
      hide: false,
      disabled: false,
      label: 'Compensation',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    clientBillRate: {
      mandatory: false,
      hide: true,
      disabled: false,
      label: 'Client Bill Rate',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    payRateExpenses: {
      mandatory: false,
      hide: true,
      disabled: false,
      label: 'Pay Rate Expenses',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    jobType: {
      mandatory: true,
      hide: false,
      disabled: false,
      availableFields: [
        'Permanent',
        'Contract',
        'Temporary',
        'Internship',
        'Freelance',
        'None',
        'PermanentAndContract',
        'ContractToHireW2',
        'ContractW2',
        'ContractIndependent',
        'ContractToHireIndependent',
        'ContractCorpToCorp',
        'ContractToHireCorpToCorp',
        'PartTime',
        'FixedTermContract',
      ],
      selectedFields: ['Permanent', 'Contract'],
      label: 'Job Type',
      selectedField: '',
    },
    jobStatusType: {
      mandatory: true,
      hide: false,
      disabled: false,
      availableFields: ['FullTime', 'PartTime', 'PerDiem'],
      label: 'Job Status',
      selectedFields: [],
      selectedField: 'FullTime',
    },
    skills: {
      mandatory: true,
      hide: false,
      disabled: false,
      label: 'Skills',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    companyName: {
      mandatory: true,
      hide: false,
      disabled: false,
      label: 'Company Name',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    clientRecruiterName: {
      mandatory: false,
      hide: false,
      disabled: false,
      label: 'Client Recruiter Name',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    tags: {
      mandatory: false,
      hide: false,
      disabled: false,
      label: 'Tags',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    clientJobCode: {
      mandatory: false,
      hide: false,
      disabled: false,
      label: 'Client Job Code',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    numberOfPositions: {
      mandatory: true,
      hide: false,
      disabled: false,
      label: 'Positions',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    accountManagerName: {
      mandatory: false,
      hide: false,
      disabled: false,
      label: 'Account Manager Name',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    insight: {
      mandatory: false,
      hide: false,
      disabled: false,
      label: 'Job Insights',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    jobIndustryName: {
      mandatory: true,
      hide: false,
      disabled: false,
      label: 'Job Industry',
      availableFields: JOB_INDUSTRY_DEFAULT,
      selectedField: '',
      selectedFields: [],
    },
    jobCategory: {
      mandatory: true,
      hide: false,
      disabled: false,
      label: 'Job Category',
      availableFields: JOB_CATEGORY_DEFAULT,
      selectedField: '',
      selectedFields: [],
    },
    jobOccupation: {
      mandatory: true,
      hide: false,
      disabled: false,
      label: 'Job Occupation',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    workAuthorization: {
      mandatory: false,
      hide: true,
      disabled: false,
      label: 'Work Authorization',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    url: {
      mandatory: false,
      hide: true,
      disabled: false,
      label: 'Job URL',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    otherBenefitDetails: {
      mandatory: false,
      hide: false,
      disabled: false,
      label: 'Benefits',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    jobSource: {
      mandatory: false,
      hide: true,
      disabled: false,
      label: 'Job Source',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    visaRequirements: {
      mandatory: false,
      hide: true,
      disabled: false,
      label: 'Visa Status',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    qualifications: {
      mandatory: false,
      hide: true,
      disabled: true,
      label: 'Qualifications',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    educationRequirements: {
      mandatory: false,
      hide: true,
      disabled: false,
      label: 'Education Required',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    experienceRequirements: {
      mandatory: false,
      hide: true,
      disabled: false,
      label: 'Experience Required',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    taxTerms: {
      mandatory: false,
      hide: false,
      disabled: false,
      label: 'Tax Terms',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    hiringFor: {
      mandatory: false,
      hide: true,
      disabled: false,
      label: 'Hiring For',
      availableFields: HIRING_FOR_DEFAULT,
      selectedField: '',
      selectedFields: HIRING_FOR_DEFAULT,
    },
    workDuration: {
      mandatory: false,
      hide: true,
      disabled: false,
      label: 'Work Duration',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
    defaultCurrency: {
      disabled: false,
      label: 'Default Currency',
      availableFields: [''],
      selectedField: '',
      mandatory: false,
      hide: false,
      selectedFields: [],
    },
    workplacePreference: {
      disabled: false,
      label: 'Workplace Preference',
      availableFields: WORKPLACE_PREFERENCES,
      selectedField: '',
      mandatory: false,
      hide: false,
      selectedFields: WORKPLACE_PREFERENCES,
    },
    businessUnit: {
      disabled: false,
      label: 'Business Unit',
      availableFields: [],
      selectedField: '',
      mandatory: false,
      hide: true,
      selectedFields: [],
    },
    submissionFormTemplete: {
      disabled: false,
      label: 'Submission Form Template',
      availableFields: [],
      selectedField: '',
      mandatory: false,
      hide: true,
      selectedFields: [],
    },
    adminTeamSelectionMandatory: false,
    feeArrangement: {
      mandatory: false,
      hide: true,
      disabled: false,
      label: 'Fee Arrangement',
      availableFields: [],
      selectedField: '',
      selectedFields: [],
    },
  };
};
